import React from 'react';
import styled from '@emotion/styled';

interface Props {
  color: string;
}

const Component: React.FCX<Props> = ({ children, className }) => <div className={className}>{children}</div>;

const StyledComponent = styled(Component)`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  background-color: ${({ color }) => color};
  position: relative;
  padding: 5vh 0;
`;

export default StyledComponent;
